import { IDownloadColumn } from '@kurtosys/types/api/downloads/IDownloadColumn.js';
import { IQueryOptions } from '@kurtosys/types/query/index.js';

export class CsvDownloader {
	filename: string;
	filenameInputs: object;
	rowsQuery: IQueryOptions;
	columns: IDownloadColumn[];
	constructor(filename: string, filenameInputs: object, rowsQuery: IQueryOptions, columns: IDownloadColumn[]) {
		this.filename = filename;
		this.filenameInputs = filenameInputs;
		this.rowsQuery = rowsQuery;
		this.columns = columns;
	}
	// Use a default field for currency for formatting
	get csvText(): string {
		return '';
	}
}
